import { createSelector } from '@reduxjs/toolkit';

import { selectAllImprovements } from './propertyDataSelectors/improvementsSelectors.ts';

export const selectOrderHasManufacturedProperty = createSelector(
  [selectAllImprovements],
  (improvements) => improvements.some(({ propertyType }) => propertyType === 'manufacturedHome'),
);
